<template>
  <a-modal
    title="编辑中成药/西药信息表"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item v-show="false"><a-input v-decorator="['medicineid']" /></a-form-item>
        <a-form-item
          label="药品编码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入药品编码（药品唯一编码，各医疗机构药品编码）" v-decorator="['medicinecode', {rules: [{required: true, message: '请输入药品编码（药品唯一编码，各医疗机构药品编码）！'}]}]" />
        </a-form-item>
        <a-form-item
          label="药品名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入药品名称" v-decorator="['medicinename', {rules: [{required: true, message: '请输入药品名称！'}]}]" />
        </a-form-item>
        <a-form-item
          label="拼音"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入拼音" v-decorator="['pinyin', {rules: [{required: true, message: '请输入拼音！'}]}]" />
        </a-form-item>
        <a-form-item
          label="药品分类CODE"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入药品分类CODE" v-decorator="['mSortcode']" />
        </a-form-item>
        <a-form-item
          label="药品分类名称（冗余字段）"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入药品分类名称（冗余字段）" v-decorator="['mSortname']" />
        </a-form-item>
        <a-form-item
          label="药品类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
         <a-select placeholder="请输入药品类型" :options="medicinetypeList"  v-decorator="['medicinetype']"></a-select>
        </a-form-item>
        <a-form-item
          label="规格"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入规格" v-decorator="['specification']" />
        </a-form-item>
        <a-form-item
          label="剂型名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-select placeholder="请输入剂型名称" :options="dosenameList" show-search  :filter-option="filterOption1" v-decorator="['doseid', {rules: [{required: true, message: '请输入剂型名称！'}]}]"  label-in-value  @change="handleChange1"></a-select>
        </a-form-item>
        <a-form-item
          label="生产商名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请输入生产商名称" :options="manunameList" show-search  :filter-option="filterOption3" v-decorator="['manuid']"  label-in-value  @change="handleChange2"></a-select>
        </a-form-item>
        <a-form-item
          label="供应商ID（暂不使用）"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入供应商ID（暂不使用）" v-decorator="['supplierid', {rules: [{required: true, message: '请输入供应商ID（暂不使用）！'}]}]" />
        </a-form-item>
        <a-form-item
          label="用药途径"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择用药途径" :options="usagenameList" show-search  :filter-option="filterOption7" v-decorator="['usagecode']" label-in-value  @change="handleChange3"></a-select>
        </a-form-item>
        <a-form-item
          label="基准单位编码（最小服药单位编码）"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入基准单位编码（最小服药单位编码）" v-decorator="['baseUnitid', {rules: [{required: true, message: '请输入基准单位编码（最小服药单位编码）！'}]}]" />
        </a-form-item>
        <a-form-item
          label="基准单位（最小服药单位）"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入基准单位（最小服药单位）" v-decorator="['baseUnit', {rules: [{required: true, message: '请输入基准单位（最小服药单位）！'}]}]" />
        </a-form-item>
        <a-form-item
          label="剂量单位编码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入剂量单位编码" v-decorator="['mediUnitid', {rules: [{required: true, message: '请输入剂量单位编码！'}]}]" />
        </a-form-item>
        <a-form-item
          label="剂量单位"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入剂量单位" v-decorator="['mediUnit', {rules: [{required: true, message: '请输入剂量单位！'}]}]" />
        </a-form-item>
        <a-form-item
          label="最小包装单位（最小发药单位）"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入最小包装单位（最小发药单位）" v-decorator="['packageUnitid', {rules: [{required: true, message: '请输入最小包装单位（最小发药单位）！'}]}]" />
        </a-form-item>
        <a-form-item
          label="包装单位"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入包装单位" v-decorator="['packageUnit', {rules: [{required: true, message: '请输入包装单位！'}]}]" />
        </a-form-item>
        <a-form-item
          label="剂量单位转换系数"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-input placeholder="请输入剂量单位转换系数（与最小服药单位位进行转换：N 剂量单位 = 1 基准单位）" v-decorator="['mediFactor']" />
        </a-form-item>
        <a-form-item
          label="暂不使用—售价单位转换系数"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-input placeholder="请输入（与最小发药单位进行转换：1 售价单位 = N 最小发药单位）" v-decorator="['feeFactor']" />
        </a-form-item>
        <a-form-item
          label="最小包装单位转换系数"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-input placeholder="请输入最小包装单位转换系数（与最小发药单位进行转换：1 包装单位 = N 最小发药单位）" v-decorator="['packageFactor']" />
        </a-form-item>
        <a-form-item
          label="频次名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-select placeholder="请选择频次名称" :options="freqnameList" show-search  :filter-option="filterOption8" v-decorator="['freqcode']" label-in-value  @change="handleChange4"></a-select>
        </a-form-item>
        <a-form-item
          label="默认频次天数"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入默认频次天数" v-decorator="['defDays', {rules: [{required: true, message: '请输入默认频次天数！'}]}]" />
        </a-form-item>
        <a-form-item
          label="默认频次次数"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入默认频次次数" v-decorator="['defTimes', {rules: [{required: true, message: '请输入默认频次次数！'}]}]" />
        </a-form-item>
        <a-form-item
          label="默认单次剂量"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-input placeholder="请输入默认单次剂量" v-decorator="['defDosage']" />
        </a-form-item>
        <a-form-item
          label="最大剂量"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-input placeholder="请输入最大剂量" v-decorator="['maxDosage']" />
        </a-form-item>
        <a-form-item
          label="批准文号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入批准文号（国药准字或者注册号）" v-decorator="['approveNo', {rules: [{required: true, message: '请输入批准文号（国药准字或者注册号）！'}]}]" />
        </a-form-item>
        <a-form-item
          label="有效期"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择有效期" v-decorator="['validDate',{rules: [{ required: true, message: '请选择有效期！' }]}]" @change="onChangevalidDate"/>
        </a-form-item>
        <a-form-item
          label="医保备注"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-input placeholder="请输入医保备注" v-decorator="['medinsrem']" />
        </a-form-item>
        <a-form-item
          label="精品中药"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择精品中药" :options="fineflagList" show-search  :filter-option="filterOption4" v-decorator="['fineflag']"></a-select>
        </a-form-item>
        <a-form-item
          label="使用标记"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择使用标记" :options="useflagList" show-search  :filter-option="filterOption5" v-decorator="['useflag']"></a-select>
        </a-form-item>
        <a-form-item
          label="备注"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-input placeholder="请输入备注" v-decorator="['remarks']" />
        </a-form-item>
        <a-form-item
          label="用药途径"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-input placeholder="请输入用药途径" v-decorator="['extend1']" />
        </a-form-item>
        <a-form-item
          label="频次名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-input placeholder="请输入频次名称" v-decorator="['extend2']" />
        </a-form-item>
        <a-form-item
          label="基本药品"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择基本药品" :options="baseflagList" show-search  :filter-option="filterOption6" v-decorator="['baseflag']"></a-select>
        </a-form-item>
        <a-form-item
          label="处方药品"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择处方药品" :options="rxflagList" show-search  :filter-option="filterOption6" v-decorator="['rxflag']"></a-select>
        </a-form-item>
        <a-form-item
          label="新药"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择新药" :options="newflagList" show-search  :filter-option="filterOption6" v-decorator="['newflag']"></a-select>
        </a-form-item>
        <a-form-item
          label="保健品"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择保健品" :options="hpflagList" show-search  :filter-option="filterOption6" v-decorator="['hpflag']"></a-select>
        </a-form-item>

        <a-form-item
          label="贵重药品"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择贵重药品" :options="costlyflagList" show-search  :filter-option="filterOption6" v-decorator="['costlyflag']"></a-select>
        </a-form-item>

        <a-form-item
          label="麻药"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择麻药" :options="numbflagList" show-search  :filter-option="filterOption6" v-decorator="['numbflag']"></a-select>
        </a-form-item>

        <a-form-item
          label="毒物"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择毒物" :options="drugflagList" show-search  :filter-option="filterOption6" v-decorator="['drugflag']"></a-select>
        </a-form-item>

        <a-form-item
          label="是否抗菌药"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择是否抗菌药" :options="antisepticflagList" show-search  :filter-option="filterOption6" v-decorator="['antisepticflag']"></a-select>
        </a-form-item>

        <a-form-item
          label="大输液"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择大输液" :options="liflagList" show-search  :filter-option="filterOption6" v-decorator="['liflag']"></a-select>
        </a-form-item>
        <a-form-item
          label="工伤"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择工伤" :options="wilimitflagList" show-search  :filter-option="filterOption6" v-decorator="['wilimitflag']"></a-select>
        </a-form-item>
        <a-form-item
          label="注射类"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择注射类" :options="injectionflagList" show-search  :filter-option="filterOption6" v-decorator="['injectionflag']"></a-select>
        </a-form-item>
        <a-form-item
          label="是否口服药"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择是否口服药" :options="oralflagList" show-search  :filter-option="filterOption6" v-decorator="['oralflag']"></a-select>
        </a-form-item>
        <a-form-item
          label="是否外用药"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择是否外用药" :options="externalflagList" show-search  :filter-option="filterOption6" v-decorator="['externalflag']"></a-select>
        </a-form-item>
        <a-form-item
          label="是否皮试药"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择是否皮试药" :options="skintestflagList" show-search  :filter-option="filterOption6" v-decorator="['skintestflag']"></a-select>
        </a-form-item>
        <a-form-item
          label="医保等级"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择医保等级" :options="medinslevelList" show-search  :filter-option="filterOption6" v-decorator="['medinslevel']"></a-select>
        </a-form-item>
        <a-form-item
          label="所属药房"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择所属药房" :options="pharmacynameList" show-search  :filter-option="filterOption6" v-decorator="['pharmacycode']"></a-select>
        </a-form-item>
        <a-form-item
          label="用法用量"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-input placeholder="请输入用法用量" v-decorator="['useType']" />
        </a-form-item>
        <a-form-item
          label="国家标准编码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        <a-input placeholder="请输入国家标准编码" v-decorator="['extend3']" />
        </a-form-item>
        <a-form-item
          label="单位选择"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择单位选择" :options="proDrugUnitList" show-search  :filter-option="filterOption6" v-decorator="['proDrugUnit']"></a-select>
        </a-form-item>

        <a-form-item
          label="来源"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-select placeholder="请选择来源" :options="channelList" show-search  :filter-option="filterOption6" v-decorator="['channel']"></a-select>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import moment from 'moment'
  import { baMedicineEdit, baDatadictDetailList, babaPharmacyList } from '@/api/modular/interhospital/bamedicine/baMedicineManage'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 7 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        validDateDateString: '',
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this),
        dosenameList: [],
        datadictDetailList: [],
        manunameList: [],
        freqnameList: [],
        usagenameList: [],
        fineflagList: [
          {
            label:'否',
            value: 0
          },
          {
            label:'是',
            value: 1
          },
        ],
        useflagList:  [
          {
            label:'未使用',
            value: '0'
          },
          {
            label:'使用',
            value: '1'
          },
        ],
        channelList:  [
          {
            label:'his',
            value: 0
          },
          {
            label:'管理后台',
            value: 1
          },
        ],
        baseflagList: [
          {
            label:'否',
            value: '0'
          },
          {
            label:'是',
            value: '1'
          },
        ],
        rxflagList: [
          {
            label:'否',
            value: '0'
          },
          {
            label:'是',
            value: '1'
          },
        ],
        newflagList: [
          {
            label:'否',
            value: '0'
          },
          {
            label:'是',
            value: '1'
          },
        ],
        hpflagList: [
          {
            label:'否',
            value: '0'
          },
          {
            label:'是',
            value: '1'
          },
        ],
        costlyflagList: [
          {
            label:'否',
            value: '0'
          },
          {
            label:'是',
            value: '1'
          },
        ],
        numbflagList: [
          {
            label:'否',
            value: '0'
          },
          {
            label:'是',
            value: '1'
          },
        ],
        drugflagList:[
          {
            label:'否',
            value: '0'
          },
          {
            label:'是',
            value: '1'
          },
        ],
        antisepticflagList:[
          {
            label:'否',
            value: '0'
          },
          {
            label:'是',
            value: '1'
          },
        ],
        liflagList:[
          {
            label:'否',
            value: '0'
          },
          {
            label:'是',
            value: '1'
          },
        ],
        wilimitflagList:[
          {
            label:'否',
            value: '0'
          },
          {
            label:'是',
            value: '1'
          },
        ],
        injectionflagList:[
          {
            label:'否',
            value: '0'
          },
          {
            label:'是',
            value: '1'
          },
        ],
        oralflagList: [
          {
            label:'否',
            value: '0'
          },
          {
            label:'是',
            value: '1'
          },
        ],
        externalflagList: [
          {
            label:'否',
            value: '0'
          },
          {
            label:'是',
            value: '1'
          },
        ],
        skintestflagList: [
          {
            label:'否',
            value: '0'
          },
          {
            label:'是',
            value: '1'
          },
        ],
        medinslevelList:[
          {
            label:'甲级（非自付）',
            value: '1'
          },
          {
            label:'乙级（部分自付）',
            value: '2'
          },
          {
            label:'全自付',
            value: '3'
          },
        ],
        medicinetypeList: [
          {
            label:'中成药',
            value: '1'
          },
          {
            label:'西药',
            value: '2'
          },
        ],
        proDrugUnitList:[
          {
            label:'基本单位',
            value: '1'
          },
          {
            label:'最小单位',
            value: '2'
          },
        ],
        pharmacynameList: [],
        getselectValue: {},
        record: {},
      }
    },
    methods: {
      moment,
      // 初始化方法
      edit (record) {
        this.visible = true
        this.getDosenameList()
        this.getManunameList()
        this.getUsagenameList()
        this.getFreqnameList()
        this.getpharmacynameList()
        setTimeout(() => {
          this.form.setFieldsValue(
            {
              medicineid: record.medicineid,
              medicinecode: record.medicinecode,
              medicinename: record.medicinename,
              pinyin: record.pinyin,
              mSortcode: record.mSortcode,
              mSortname: record.mSortname,
              medicinetype: record.medicinetype,
              specification: record.specification,
              doseid: {'key': record.doseid, 'label': record.dosename },
              dosename: record.dosename,
              manuid:  {'key':record.manuid, 'label': record.manuname },
              manuname: record.manuname,
              supplierid: record.supplierid,
              usagecode: {'key':record.usagecode, 'label': record.usagename },
              usagename: record.usagename,
              baseUnitid: record.baseUnitid,
              baseUnit: record.baseUnit,
              mediUnitid: record.mediUnitid,
              mediUnit: record.mediUnit,
              packageUnitid: record.packageUnitid,
              packageUnit: record.packageUnit,
              mediFactor: record.mediFactor,
              feeFactor: record.feeFactor,
              packageFactor: record.packageFactor,
              freqcode: {'key': record.freqcode, 'label': record.freqname },
              freqname: record.freqname,
              defDays: record.defDays,
              defTimes: record.defTimes,
              defDosage: record.defDosage,
              maxDosage: record.maxDosage,
              approveNo: record.approveNo,
              remarks: record.remarks,
              medinsrem: record.medinsrem,
              fineflag: record.fineflag,
              useflag: record.useflag,
              extend1: record.extend1,
              extend2: record.extend2,
              baseflag: record.baseflag,
              rxflag: record.rxflag,
              newflag: record.newflag,
              hpflag: record.hpflag,
              costlyflag: record.costlyflag,
              numbflag: record.numbflag,
              drugflag: record.drugflag,
              antisepticflag: record.antisepticflag,
              liflag: record.liflag,
              wilimitflag: record.wilimitflag,
              injectionflag: record.injectionflag,
              oralflag: record.oralflag,
              externalflag: record.externalflag,
              skintestflag: record.skintestflag,
              medinslevel: record.medinslevel,
              pharmacycode: record.pharmacycode,
              useType: record.useType,
              extend3: record.extend3,
              proDrugUnit: record.proDrugUnit,
              channel: record.channel,
              
              
            }
          )
          this.record = record
        }, 100)
        // 时间单独处理
        if (record.validDate != null) {
            this.form.getFieldDecorator('validDate', { initialValue: moment(record.validDate, 'YYYY-MM-DD') })
        }
        this.validDateDateString = moment(record.validDate).format('YYYY-MM-DD')
      },
      handleChange1(value){
        console.log('走这了强刷新')
        const { label, key } = value;
        this.getselectValue.dosename = label
        this.getselectValue.doseid = key
      },
      handleChange2(value){
        const { label, key } = value;
        this.getselectValue.manuname = label
        this.getselectValue.manuid = key
      },
      handleChange3(value){
        const { label, key } = value;
        this.getselectValue.usagename = label
        this.getselectValue.usagecode = key
      },
      handleChange4(value){
        const { label, key } = value;
        this.getselectValue.freqname = label
        this.getselectValue.freqcode = key 
      },
      handleSubmit () {
        const { form: { validateFields } } = this
        this.confirmLoading = true
        validateFields((errors, values) => {
          if (!errors) {
            for (const key in values) {
              if (typeof (values[key]) === 'object') {
                values[key] = JSON.stringify(values[key])
              }
            }
            values.validDate = this.validDateDateString
            if(!this.getselectValue.usagecode){
              this.getselectValue.usagename = this.record.usagename;
              this.getselectValue.usagecode = this.record.usagecode;
            }
            if(!this.getselectValue.doseid){
              this.getselectValue.dosename = this.record.dosename;
              this.getselectValue.doseid = this.record.doseid;
            }
            if(!this.getselectValue.manuid){
              this.getselectValue.manuname = this.record.manuname;
              this.getselectValue.manuid = this.record.manuid;
            }
            if(!this.getselectValue.freqcode){
              this.getselectValue.freqname = this.record.freqname;
              this.getselectValue.freqcode = this.record.freqcode;
            }
            baMedicineEdit(Object.assign(values,this.getselectValue)).then((res) => {
              if (res.success) {
                this.$message.success('编辑成功')
                this.confirmLoading = false
                this.$emit('ok', values)
                this.handleCancel()
              } else {
                this.$message.error('编辑失败')//  + res.message
              }
            }).finally((res) => {
              this.confirmLoading = false
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      onChangevalidDate(date, dateString) {
        this.validDateDateString = dateString
      },
      handleCancel () {
        this.form.resetFields()
        this.visible = false
      },
      getDosenameList() {
        baDatadictDetailList({
          dictId: 26
        }).then(res => {
          if (res.code == 200) {
            this.dosenameList = [];
            res.data.map(item => {
              this.dosenameList.push({
                value: item.detailValue,
                label: item.detailName
              })
            })
          } else {
            this.$message.error(res.message)
          }
        })
      },
      getManunameList() {
        baDatadictDetailList({
          dictId: 17
        }).then(res => {
          if (res.code == 200) {
            this.manunameList = [];
            res.data.map(item => {
              this.manunameList.push({
                value: Number(item.detailValue),
                label: item.detailName
              })
            })
          } else {
            this.$message.error(res.message)
          }
        })
      },
      getFreqnameList() {
        baDatadictDetailList({
          dictId: 16
        }).then(res => {
          if (res.code == 200) {
            this.freqnameList = [];
            res.data.map(item => {
              this.freqnameList.push({
                value: item.detailValue,
                label: item.detailName
              })
            })
          } else {
            this.$message.error(res.message)
          }
        })
      },
      
      getUsagenameList() {
        baDatadictDetailList({
          dictId: 23
        }).then(res => {
          if (res.code == 200) {
            this.usagenameList = [];
            res.data.map(item => {
              this.usagenameList.push({
                value: item.detailValue,
                label: item.detailName
              })
            })
          } else {
            this.$message.error(res.message)
          }
        })
      },
      getpharmacynameList() {
        babaPharmacyList().then(res => {
          if (res.code == 200) {
            this.pharmacynameList = [];
            res.data.map(item => {
              this.pharmacynameList.push({
                value: item.pharmacyCode,
                label: item.pharmacyName
              })
            })
          } else {
            this.$message.error(res.message)
          }
        })
      },
      
      filterOption1(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      filterOption2(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      filterOption3(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      filterOption4(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      filterOption5(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      filterOption6(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      filterOption7(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      filterOption8(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
    }
  }
</script>
<style lang="less" scoped>

/deep/ .ant-form-item-label{
  text-overflow: ellipsis;
}

.ant-calendar-picker-container{
  z-index: 2000;
}
</style>
